import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";
import { TSubscriptionRulesPaginated } from "../types";

export const QUERY_KEY_SUBSCRIPTION_RULES = "admin-subscription-rules";

const getData = async (props: {
  token: string;
  page: number;
  packageId?: string;
}): Promise<TSubscriptionRulesPaginated> => {
  const params = new URLSearchParams({ page: String(props.page) });
  if (props.packageId) {
    params.append("package_id", props.packageId);
  }
  const url = `${END_POINT.BASE_URL}/v1/administrator/subscription-rules?${params.toString()}`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const res = await axios.get<TSubscriptionRulesPaginated>(url, config);
  return res.data;
};

export const useGetSubscriptionRules = (page: number, packageId?: string) => {
  const { token } = useGetUserInfo();
  return useQuery(
    [QUERY_KEY_SUBSCRIPTION_RULES, page, packageId ?? ""],
    () =>
      getData({
        token,
        page,
        packageId,
      }),
    {
      keepPreviousData: true,
    }
  );
};
